import React, { useContext, useEffect, useState } from 'react';
import {motion} from "framer-motion";
import axios from 'axios';
import {AppContext} from "../../context/app/appContext";
import {useHistory, useParams} from "react-router-dom";
import {Dimmer, Loader, Modal, Button} from "semantic-ui-react";

export const OnboardingIntegrationAdmin = (props) => {
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
    // const history = useHistory();
    // const appContext = useContext(AppContext);
    const { type, orgId } = useParams();

    const [showInfoModal, setShowInfoModal] = useState(false)
    const [infoModalData, setInfoModalData] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            checkForAuth();
        }, 2000);
        return () => clearTimeout(timer);
    }, []);

    const checkForAuth = () => {
        switch(type) {
            case 'gSuite':
                googleSDK();
                break;
            default:
                break;
        }
    }

    const googleSDK = () => {
        (function(d, s, id){
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
            fjs.parentNode.insertBefore(js, fjs);
          }(document, 'script', 'google-jssdk'));

        window['googleSDKLoaded'] = () => {
            window['gapi'].load('auth2', () => {
                window['gapi'].auth2.init({
                    apiKey: 'AIzaSyBFceVWC7ZJ4Pmo-1gtQETtvmvs_kdf6qc',
                    client_id: '955194124980-95bldgbkns78cqbvb2k45vqjilhogrb6.apps.googleusercontent.com',
                    discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/admin/directory_v1/rest"],
                    scope: 'https://www.googleapis.com/auth/admin.directory.user.readonly',
                //   redirect_uri: 'https://www.google.com'
                }).then((r) => {
                    console.log("Here")
                    console.log(window['gapi'].auth2.getAuthInstance().isSignedIn.get())
                    if(window['gapi'].auth2.getAuthInstance().isSignedIn.get()){
                        console.info({r})
                    }
                    var options = new window['gapi'].auth2.SigninOptionsBuilder();
                    options.setPrompt('select_account');
                    window['gapi'].auth2.getAuthInstance().signIn(options).then(async resp => {
                        const onboardingStatusUpdate = await axios.post(`${baseURL}/onboard-provider/status`, {provider: 'gSuite', status: 'requested', organizationId: orgId});
                        console.log("My data", onboardingStatusUpdate)
                        if (onboardingStatusUpdate.status === 200) {
                            const splitEmail = resp.getBasicProfile().getEmail().split('@')
                            const domain = splitEmail[splitEmail.length-1]
                            console.info({domain})
                            const gSuiteOnboardResponse = await axios.post(baseURL + "/gSuite-accessToken", {accessToken: resp.getAuthResponse().access_token, organizationId: orgId, domain})
                            // console.info(resp.directory)
                            // console.log(window['gapi'].client)
                            console.info({gSuiteOnboardResponse})
                            if(gSuiteOnboardResponse.status === 200){
                                setInfoModalData(gSuiteOnboardResponse.data.data.result)
                                setShowInfoModal(true) 
                            }
                        }
                        // resp.disconnect()
                        window['gapi'].auth2.disconnect();
                    })
                }).catch(error => {
                    console.info({error})
                })
            });
        }
     
        // (function(d, s, id){
        //   var js, fjs = d.getElementsByTagName(s)[0];
        //   if (d.getElementById(id)) {return;}
        //   js = d.createElement(s); js.id = id;
        //   js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
        //   fjs.parentNode.insertBefore(js, fjs);
        // }(document, 'script', 'google-jssdk'));
    }

    return (
        <div style={{width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center'}}>
            <div style={{alignSelf: 'center', fontSize: 18}}>You are onboarding using: {type}</div>
            <Modal dimmer={'blurring'} open={showInfoModal} size="mini">
                <Modal.Content><p>Onboarding Complete</p></Modal.Content>
                {infoModalData ? 
                    <Modal.Content>
                        <p><div style={{color: '#00CF8F'}}>Successfully Uploaded ({infoModalData['success'].length}):</div>
                        <div>{infoModalData['success'].map(name => {return <div>{name}</div>})}</div></p>
                        <p><div style={{color: '#FF5A5F'}}>Failed to upload ({infoModalData['fail'].length}):</div>
                        <div>{infoModalData['fail'].map(name => {return <div>{name}</div>})}</div></p>
                    </Modal.Content>
                :null}
                <Modal.Actions className="center aligned"><Button onClick={e => setShowInfoModal(false)}>Ok</Button></Modal.Actions>
            </Modal>
        </div>
    )

}